import { render } from "./NkAssignmentTurnedIn.vue?vue&type=template&id=a7ebc9dc"
const script = {}

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__